var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconReader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 16,
    viewBox: "0 0 16 16",
    width: 16,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgb(88, 106, 218)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m4.5 0h7c.8284271 0 1.5.67157288 1.5 1.5v11c0 .8284271-.6715729 1.5-1.5 1.5h-7c-.82842712 0-1.5-.6715729-1.5-1.5v-11c0-.82842712.67157288-1.5 1.5-1.5zm.5 2v6h6v-6zm0 13h6v.5c0 .2761424-.2238576.5-.5.5h-5c-.27614237 0-.5-.2238576-.5-.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReader);
export default __webpack_public_path__ + "static/media/icon-reader.76d6263592a87f19e16a96d144471c6c.svg";
export { ForwardRef as ReactComponent };